module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Adres e-mail",
      "name": "email",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz adres e-mail"
    },
    model: {
      value: (_vm.item.email),
      callback: function($$v) {
        _vm.item.email = $$v
      },
      expression: "item.email"
    }
  }), _vm._v(" "), _c('i-select-multiple', {
    attrs: {
      "name": "groups",
      "label": "Grupy",
      "keys": _vm.keysForSelect,
      "options": _vm.groups,
      "search-placeholder": "Szukaj",
      "show-search": true,
      "placeholder": "Wybierz grupy",
      "required": ""
    },
    model: {
      value: (_vm.item.groups_ids),
      callback: function($$v) {
        _vm.item.groups_ids = $$v
      },
      expression: "item.groups_ids"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.item.id ? 'Aktualizuj' : 'Dodaj'))])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85952620","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emails/Form.vue
// module id = 278
// module chunks = 0